import { format } from 'date-fns';
import { graphql, useStaticQuery } from 'gatsby';
import React, { useEffect, useState } from 'react';
import { css } from 'styled-components';
import { Button, H6, HR, IconCertificate, IconCheck, IconClockFast, P, Small } from '@upsolve/ui';

import MockPhone from './MockPhone';
import ImageStaticMap from '../Media/ImageStaticMap';

const court = {
  name: 'Conrad B. Duberstein United States Bankruptcy Courthouse',
  address: {
    display: '271-C Cadman Plaza East Brooklyn, NY 11201', number: '271-C', street: 'Cadman Plaza East', city: 'Brooklyn', state: 'NY', zipcode: '11201',
  },
  url: 'http://www.uscourts.gov/court-locator/new-york-eastern-bankruptcy-court-brooklyn',
  phone: '347-394-1700',
  state: 'NY',
  district: 'nyeb',
  coordinates: { latitude: 40.696145, longitude: -73.99005 },
};

const PhoneDemoChecklistFiling = () => {
  return (
    <MockPhone cssOverrides={cssOverrides}>
      <div className="phone__checklist__step done">
        <IconCheck /> Credit Counseling
      </div>
      <div className="phone__checklist__step done">
        <IconCheck /> Forms Downloaded
      </div>
      <div className="phone__checklist__step expanded">
        <IconClockFast /> File at Courthouse
        <div className="explainer">
          <ImageStaticMap
            alt={court.name}
            {...court.coordinates}
            height={140}
            width={240}
            zoom={11}
          />
          <Small as="p"><b>Court</b>: {court.name}</Small>
          <Small as="p"><b>Hours</b>: M-F, 9-5pm</Small>
          {/* <Small as="p"><b>Address</b>: {court.address.display}</Small> */}
          <Button size="sm" width="100%" inverted buttonType="default">Read Requirements</Button>
          <Button size="sm" width="100%" inverted buttonType="default">Get Directions</Button>
        </div>
      </div>
    </MockPhone>
  );
}

const cssOverrides = css`
  transform: rotate(2deg);
  @media(max-width: ${props => props.theme.breakpoints[500]}) {
    transform: rotate(0);
  }
  .phone__checklist {
    margin-top: -1em;
    // margin-top: -3em;
  }
`;

export default PhoneDemoChecklistFiling;
